import * as React from 'react';

import styles from './aside.module.css';

type Props = {
    children: React.ReactNode;
};

export function Aside(props: Props) {
    return <div className={styles.aside}>{props.children}</div>;
}
